import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "../ContactUs/Contactus.css";
import { Container, Row, Button, Col } from "react-bootstrap";
import content from '../content.json';
import parse from 'html-react-parser';
import Error from '../error/ErrorPage';
import Header from "../Header/index";
import Body from "../Body/Body";
import Contactus from "../ContactUs/Contactus";
import useLOData from "../Utils/useLOData.js";
import ReadyToChase from '../Unwrap/unwrap';
import Footer from '../FooterNew/index';
import axios from "axios";

function LOPage() {

    const [dataJson, setDataJson] = useState(null); // Set initial state as null
    const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
    const [loanOfficerUid, setLoanOfficerUid] = useState('');
    const { loName } = useParams();
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { agentName } = useParams();
    const agentJsonName = agentName + ".json";
    const [loading, setLoading] = useState(true);
    const [loadBodyData, setLoadBodyData] = useState(true);
    const [agentData, setAgentData] = useState();
    const [loanOfficerActive, setLoanOfficerActive] = useState(true);
    const [loanOfficerData, setLoanOfficerData] = useState();
    const [realorData, setRealtorData] = useState();
    const [aiBrandingData, setAiBrandingData] = useState();
    const [angelAiUserInfo, setAngelAiUserInfo] = useState();
    const [data, setData] = useState(null); // Set initial state as null
 
    const newData = useLOData(agentName);

    // console.log(agentName)
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const timestamp = Date.now(); // Generate a unique timestamp
                const response = await fetch(`${process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_JSON}?timestamp=${timestamp}`);
                const jsonData = await response.json();
                setDataJson(jsonData);
            } catch (error) {
                console.error('Error fetching links:', error);
                setDataJson(content); // Use local JSON data if fetching fails
            }
        };

        if (!dataJson) {
            fetchData(); // Fetch JSON only if the links data is not available
        }
    }, [dataJson]);

    useEffect(() => {
        if (!dataJson) {
            setDataJson(content); // Set local JSON data as fallback initially
        }
    }, []);

  
// console.log(newData, "suresh2")
if (newData === null){return <div>Loading...</div>}

    return (
        <div>
            {dataJson ? (
                <>
                    <Header fetchpriority="high" />
                    <Body fetchpriority="high" dataJson={dataJson.body} 
                    newData = {newData}
                    
                    />
                    <Suspense fallback={<div />}>
                        <ReadyToChase dataJson={dataJson.unwrap} 
                        
                         />
                    </Suspense>
                    <Contactus dataJson={dataJson.disclaimer}
                    newData = {newData}
                     />
                    <Suspense fallback={<div />}>
                        <Footer />
                    </Suspense>
                </>
            ) : (
                <div className='loading'>Loading...</div>
            )}

        </div>
    );
}

export default LOPage;
